import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ShoppingBag, LogIn, LayoutDashboard } from 'lucide-react';
import './PublicLayout.css';

export default function PublicLayout() {
  const { user, loading } = useAuth();

  return (
    <div className="public-shell">
      {/* Top navbar */}
      <header className="public-nav">
        <Link to="/" className="public-nav-logo">
          <div className="public-nav-logo-icon">G</div>
          <span>GLA Exchange</span>
        </Link>

        <nav className="public-nav-links">
          <Link to="/explore" className="public-nav-link">Marketplace</Link>
          <Link to="/about" className="public-nav-link">About</Link>
        </nav>

        <div className="public-nav-right">
          {!loading && (
            user
              ? <Link to="/app/dashboard" className="btn btn-primary btn-sm">
                  <LayoutDashboard size={15} /> Dashboard
                </Link>
              : <Link to="/login" className="btn btn-primary btn-sm">
                  <LogIn size={15} /> Sign In
                </Link>
          )}
        </div>
      </header>

      {/* Page content */}
      <main className="public-main">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="public-footer">
        <div className="public-footer-inner">
          <div className="public-footer-brand">
            <div className="public-nav-logo-icon" style={{ width: 28, height: 28, fontSize: '0.85rem' }}>G</div>
            <span style={{ fontFamily: 'var(--font-display)', fontWeight: 600 }}>GLA Exchange</span>
          </div>
          <p className="public-footer-desc">
            Campus marketplace exclusively for GLA University students, Mathura.
          </p>
          <div className="public-footer-links">
            <Link to="/explore">Marketplace</Link>
            <Link to="/about">About</Link>
            <Link to="/install">Install App</Link>
          </div>
          <p className="public-footer-copy">
            © 2024 GLA Exchange · Built for GLA University · Mathura, UP
          </p>
        </div>
      </footer>
    </div>
  );
}